<hr
  *ngIf="
    isBalancePayButtonVisible ||
    isBalanceOverduePayButtonVisible ||
    isTransactionPayButtonVisible
  "
/>
<div
  class="rs-flex-row rs-flex-dir-col-small-only"
  *ngIf="
    isBalancePayButtonVisible && isBalanceOverduePayButtonVisible;
    else showSinglePayButton
  "
>
  <div class="rs-flex-column rs-order-m2">
    <my-bill-pay-button
      [billingAccount]="billingAccount"
      payButtonLevel="balance"
      [payButtonText]="balancePayButtonText"
      [hasClassTextRight]="false"
    >
    </my-bill-pay-button>
  </div>
  <div class="rs-flex-column rs-flex-shrink rs-order-m1">
    <my-bill-pay-button
      [billingAccount]="billingAccount"
      payButtonLevel="balancePOP"
      [payButtonText]="overduePayButtonText"
      [hasClassTextRight]="false"
      [hasLeftPosition]="true"
    >
    </my-bill-pay-button>
  </div>
</div>
<ng-template #showSinglePayButton>
  <my-bill-pay-button
    [billingAccount]="billingAccount"
    payButtonLevel="balance"
    [payButtonText]="balancePayButtonText"
    [hasClassTextRight]="false"
    *ngIf="
      isBalancePayButtonVisible &&
      !isBalanceOverduePayButtonVisible &&
      !isTransactionPayButtonVisible
    "
  >
  </my-bill-pay-button>
  <my-bill-pay-button
    [billingAccount]="billingAccount"
    payButtonLevel="balancePOP"
    [payButtonText]="overduePayButtonText"
    [hasClassTextRight]="false"
    *ngIf="
      isBalanceOverduePayButtonVisible &&
      !isBalancePayButtonVisible &&
      !isTransactionPayButtonVisible
    "
  >
  </my-bill-pay-button>
  <my-bill-pay-button
    [billingAccount]="billingAccount"
    payButtonLevel="transaction"
    [payButtonText]="transactionPayButtonText"
    [openTransactionToPayIndex]="openTransactionToPayIndex"
    [hasClassTextRight]="false"
    *ngIf="
      isTransactionPayButtonVisible &&
      !isBalancePayButtonVisible &&
      !isBalanceOverduePayButtonVisible
    "
  >
  </my-bill-pay-button>
</ng-template>
